import { connect } from "react-redux";
import { IPlayUIStateProps } from "../..";
import {
  triggerBetSettingsViewChangeRequest,
  triggerMuteChangeRequest,
  triggerQuickSpinChangeRequest
} from "../Common/Keypad.actions";
import {
  sharedMapDispatchToProps,
  sharedMapPropsToState
} from "../Common/Keypad.redux";
import {
  IKeypadMobileMapDispatchProps,
  IKeypadMobileMapStateProps
} from "./KeypadMobile";
import { KeypadMobileView } from "./KeypadMobile.view";

const mapStateToProps = (
  state: IPlayUIStateProps
): IKeypadMobileMapStateProps => {
  return {
    ...sharedMapPropsToState(state),
    muted: state.keypad.muted,
    soundButtonDisabled: state.keypad.soundButtonDisabled,
    isFullscreenGame: state.keypad.isFullscreenGame,
    isLeftHandMode: state.keypad.isLeftHandMode,
    view: state.view,
    isTickerHidden: state.ticker.hidden,
    quickSpinActive: state.keypad.quickSpin.active,
    quickSpinAvailable: state.keypad.quickSpin.available,
    quickSpinEnabled: state.keypad.quickSpin.enabled
  };
};

const mapDispatchToProps = (dispatch): IKeypadMobileMapDispatchProps => {
  return {
    ...sharedMapDispatchToProps(dispatch),
    triggerBetSettingsViewChangeRequest: () =>
      dispatch(triggerBetSettingsViewChangeRequest()),
    triggerMuteChangeRequest: (muted: boolean) => () =>
      dispatch(triggerMuteChangeRequest(muted)),
    triggerQuickSpinChangeRequest: value => () =>
      dispatch(triggerQuickSpinChangeRequest(value))
  };
};

export const KeypadMobile: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(KeypadMobileView);
